export const ownerPrincipalValidationInfoConstants = {
	REMOVE_OWNER_VALIDATION_INFO: "REMOVE_OWNER_VALIDATION_INFO",
	REMOVE_SIGNER_VALIDATION_INFO: "REMOVE_SIGNER_VALIDATION_INFO",

	VALIDATION_INFO_SET_SSN_VALID: "VALIDATION_INFO_SET_SSN_VALID",
};
